/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type AllPhasesDropdown_projects = ReadonlyArray<{
    readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly projectColor: string | null;
        readonly companyProjectId: number | null;
        readonly status: PROJECT_STATUS | null;
    } | null;
    readonly " $refType": "AllPhasesDropdown_projects";
}>;
export type AllPhasesDropdown_projects$data = AllPhasesDropdown_projects;
export type AllPhasesDropdown_projects$key = ReadonlyArray<{
    readonly " $data"?: AllPhasesDropdown_projects$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AllPhasesDropdown_projects">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllPhasesDropdown_projects",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectTypeEdge"
};
(node as any).hash = '06a49f920986d20a87a5fde27c7186a8';
export default node;
